import { cilAccountLogout, cilHome } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import { CButton } from '@coreui/react-pro'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { logout } from 'src/actions'
import { ACCESS_TOKEN_NAME, COMMON } from 'src/constants/Constants'
import { ROUTE } from 'src/constants/RouteConstants'
import { isUserEmployee } from 'src/selectors/AuthSelector'
import { isDarkTheme } from 'src/selectors/ThemeSelector'

const ErrorPage = ({ code }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { t } = useTranslation(COMMON)
  const isEmployee = useSelector(isUserEmployee)
  const isDark = useSelector(isDarkTheme)
  const token = localStorage.getItem(ACCESS_TOKEN_NAME)
  const codeText = t(`code_${code}`)

  const logoutUser = () => {
    setTimeout(() => {
      dispatch(logout())
      navigate(ROUTE.LOGIN, { replace: true })
      window.location.reload()
    }, 50)
  }

  const redirectUser = () => {
    setTimeout(() => {
      navigate(ROUTE.HOME, { replace: true })
      window.location.reload()
    }, 50)
  }

  useEffect(() => {
    if (!token) {
      logoutUser()
    }
  }, [token])

  // AppHeader owns the body class but isn't mounted outside DefaultLayout
  useEffect(() => {
    document.body.classList.toggle('dark-theme', isDark)
  }, [isDark])

  return (
    <div className="error-page">
      <main className="error-page-body">
        <div className="error-page-code" aria-label={codeText}>
          <span className="error-page-code-accent">{codeText.slice(0, 1)}</span>
          {codeText.slice(1)}
        </div>
        <h1 className="error-page-title">{t(`msg_${code}`)}</h1>
        <p className="error-page-desc text-medium-emphasis">{t(`desc_${code}`)}</p>
        <div className="error-page-actions">
          <CButton className="btn-dm3red" size="lg" type="button" onClick={redirectUser}>
            <CIcon icon={cilHome} className="me-2" />
            {t(isEmployee ? 'go_to_dashboard' : 'go_to_order_list')}
          </CButton>
          <CButton color="secondary" variant="outline" size="lg" type="button" onClick={logoutUser}>
            <CIcon icon={cilAccountLogout} className="me-2" />
            {t('re_login')}
          </CButton>
        </div>
      </main>
    </div>
  )
}

ErrorPage.propTypes = {
  code: PropTypes.oneOf(['404', '500']).isRequired,
}

export default ErrorPage
